import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createRouteRef,
} from '@backstage/core-plugin-api';

export enum RoutesIds {
  insights = 'insights',
}

enum ExternalRoutesIds {
  surface = 'surface',
}

// root route
export const insightsRouteRef = createRouteRef({ id: RoutesIds.insights });

export const rootRouteRef = insightsRouteRef;

// external routes to other plugins
export const surfaceRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.surface,
  params: ['id'],
  optional: true,
});

// default routes/routes to be used by other plugins
export const Routes = {
  insights: insightsRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  // external routes to other plugins
  surface: surfaceRouteRef,
} satisfies Record<ExternalRoutesIds, ExternalRouteRef>;
